import { useCallback } from 'react';
import { useTenantConfig } from '@packlink/tenant-config-provider';

function useLink() {
  const tenantConfig = useTenantConfig();
  const getLink = useCallback(name => {
    if (!tenantConfig || !tenantConfig.links || !name) {
      return '';
    }
    return tenantConfig.links[name] || '';
  }, [tenantConfig]);
  return getLink;
}

export { useLink };
//# sourceMappingURL=useLink.js.map
